import React, { useState } from "react";

type Props = {
  price: number | null;
  code: string;
  setCode: (code: string) => void;
};

const UseCode: React.FC<Props> = ({ price, code, setCode }) => {
  const [error, setError] = useState<string | null>("يجب ادخال الكود");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCode(value);

    // Validation: Check if input is not empty and at least 8 characters
    if (value.trim() === "") {
      setError("يجب ادخال الكود");
    } else if (value.trim().length < 8) {
      setError("يجب أن يكون طول الكود على الأقل 8 أحرف");
    } else {
      setError(null);
    }
  };

  return (
    <div className="flex flex-col gap-2 items-center justify-center text-white">
      {price && (
        <>
          <p>
            قيمة المبلغ{" "}
            <span className="font-bold text-lg text-primaryColor">{price}</span>{" "}
            جنيه
          </p>
          <p>يجب ان تكون قيمة الكود مطابقه لسعر الكورس</p>
        </>
      )}
      <div className="w-full text-right flex flex-col gap-2">
        <label
          htmlFor="code"
          className="text-16 text-white"
        >
          ادخل الكود
        </label>
        <input
          type="text"
          name="code"
          id="code"
          value={code}
          onChange={handleInputChange}
          className={`text-right placeholder:text-right h-[60px] bg-[#474A4D] py-[15px] px-[10px] rounded-[10px] text-white text-20 placeholder:text-textColor placeholder:text-16 relative outline-none block w-full after:content-['dfdf'] after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0 after:bg-[#474A4D] ${
            error ? "border border-red-500" : "border border-primaryColor"
          }`}
        />
        {error && <p className="text-red-500 text-right">{error}</p>}
      </div>
    </div>
  );
};

export default UseCode;
